export default async (args = {}) => {
  const r = [
    "Sou experiente, apesar da aparência jovem 😀😀😀",
    "Sempre terei 19 😎😁",
    "A idade ideal para aproveitar a vida.😎🤣😁"
  ];
  return r[Math.floor(Math.random() * r.length)];
}